import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlCmsCopy} from '../getCmsCopy.api';
import {CmsCopy} from '../../../graphql/common.datatypes';

export interface UpdateCmsCopyInput {
    data: {
        id: number
        key: string
        body: string
    }
}

interface UpdateCmsCopyData {
    __typename?: string,
    updateCmsCopy: CmsCopy
}

export const UPDATE_CMS_COPY_MUTATION = gql`
    mutation updateCmsCopy($data: UpdateCmsCopyInput!) {
        updateCmsCopy(data: $data) {
            ${gqlCmsCopy}
        }
    }
`;

export const updateCmsCopy = () => useMutation<UpdateCmsCopyData, UpdateCmsCopyInput>(
    UPDATE_CMS_COPY_MUTATION,
    {
        update: updateCacheByType('CmsCopy'),
    }
);

export default updateCmsCopy;